<template>
  <v-container class="full-page text-center black--text pt-5" style="background: #3BE287;">
    <v-img contain :src="require('../assets/spacestudio-blanc.png')" aspect-ratio="9" />
    <br />
    <br />
    <span class="display-3"
      ><icon scale="3" class="pb-2" name="tools" /> We will be back soon!</span
    >
    <br />
    <br />
    <h5 class="page-text">
      Sorry for the inconvenience, we are performing some maintenance at the
      moment. Do not hesitate to
      <u class="cursor-pointer" v-on:click="sendEmail()">contact us.</u>
    </h5>
  </v-container>
</template>

<script>
export default {
  name: 'MaintenancePage',
  methods: {
    sendEmail() {
      window.open('mailto:support.spacestudio@exotrail.com')
    }
  }
}
</script>

<style scoped>
.bg-blue {
  background-color: #1a64c6;
}
.full-page {
  max-width: 100% !important;
  width: 100% !important;
}
.page-text {
  font-weight: inherit;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
